export const SIDER_EXPAND_KEYS_EVENT = 'sider:expand-keys';

export const dispatchSiderExpandKeys = (keys: ReadonlyArray<string>): void => {
  window.dispatchEvent(new CustomEvent(SIDER_EXPAND_KEYS_EVENT, { detail: keys }));
};
